// The site was renamed AiComp and moved to aicomp.wetamoonshine.com (owner, 2026-10-03). The old address still
// serves the same files and sends visitors on to the new one, keeping the path, query and #fragment. Imported first
// in main.ts so it runs before anything else starts.

const OLD_HOST = 'aicompare.wetamoonshine.com';
const NEW_ORIGIN = 'https://aicomp.wetamoonshine.com';

if (location.hostname === OLD_HOST) location.replace(NEW_ORIGIN + location.pathname + location.search + location.hash);
